import { cx } from "./cx";

export interface WordmarkProps {
  /** Brand display name (alt text / text wordmark) — from the white-label config. */
  brandName: string;
  /** Wordmark contract from the theme: text + optional logo asset ref. */
  wordmark?: { text: string; logoUrl: string | null };
  href?: string;
  className?: string;
}

/**
 * Brand wordmark — reads ONLY from the white-label config (theme), never a
 * literal. Renders the logo asset when the theme provides one, otherwise the
 * text wordmark in type.family.display (DESIGN_SYSTEM.md §12).
 */
export function Wordmark({ brandName, wordmark, href, className }: WordmarkProps) {
  const body = wordmark?.logoUrl ? (
    // eslint-disable-next-line @next/next/no-img-element -- config-driven asset, size fixed by tokens
    <img className="pz-wordmark__logo" src={wordmark.logoUrl} alt={brandName} />
  ) : (
    <span className="pz-wordmark__text">{wordmark?.text ?? brandName}</span>
  );
  if (href) {
    return (
      <a className={cx("pz-wordmark", className)} href={href}>
        {body}
      </a>
    );
  }
  return <span className={cx("pz-wordmark", className)}>{body}</span>;
}
